module.exports = __webpack_public_path__ + "img/pending.3efee3be.svg";